import { ReactNode } from 'react';
import styles from './PlpFiltersMake.module.scss';

type Props = {
  label: ReactNode;
  typeLabel: string;
  testId?: string;
};

export const PlpFiltersMakeLabelSelected = ({ label, typeLabel, testId }: Props) => (
  <label className={styles.selectedOption} data-testid={testId}>
    <div className={styles.selectedOptionLabel}>{label}</div>
    <div className={styles.selectedOptionType}>{typeLabel}</div>
  </label>
);
